export const productRoutes = [
  {
    path: '/product/product-brand',
    component: () => import('@/views/modules/product/product-brand/product-brand'),
    meta: { name: '品牌资料', keepAlive: true, permission: 'brand:view' ,modal:'产品'}
  },
  {
    path: '/product/product-category',
    component: () => import('@/views/modules/product/product-category/product-category'),
    meta: { name: '品类资料', keepAlive: true, permission: 'category:view' ,modal:'产品'}
  },
  {
    path: '/product/product-manager',
    component: () => import('@/views/modules/product/product-manager/product-manager'),
    meta: { name: '产品资料', keepAlive: true, permission: 'product:view',modal:'产品' }
  },
];
